jQuery(function ($) {
    $('.switch .btn-toggle').on('click', function () {
        switch_btn(jQuery(this));
    });

    function switch_btn(btn) {
        var parent = btn.closest('.switch');
        var label = parent.find('.switch-label:not(.active)');

        parent.find('.switch-label').each(function () {
            $(this).removeClass('active');
        });

        label.addClass('active');

        if (parent.hasClass('active')) {
            parent.removeClass('active');
        } else {
            parent.addClass('active');
        }
    }
});